import React, { Component } from 'react';
import { Button, ButtonToolbar, Table, Col, Grid } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import { LineColorForm } from './LineColorForm';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { LineColorAPI } from '../../../api/datamanager/LineColorAPI';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { SearchBar } from '../../SearchBar';
import { TitleRow } from '../../TitleRow';
import { TableButton } from '../../TableButton';

import ColumnResize from "react-table-column-resizer";

export class LineColors extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
    }

    constructor(props) {
        super(props);
        this.state = {
            lineColors: [],
            lineColor: undefined,
            showLineColorForm: false,
            showDeleteModal: false,
            showExecutingModal: false,
            filter: "",
            nameInputError: null,
            backColorInputError: null,
            paperColorInputError: null,
            foreColorInputError: null,
            title: '',
            currentPage: 1,
            elementsPerPage: 50,
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
            executingMessage: <LoadingSpinner />,
            executingStyle: "primary",
            exectuingIcon: "transfer",
            executingTitle: "A Executar...",
            loading: true
        }
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        
        this.getLineColors();
    }

    // ----------------------

    getLineColors() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        let lineColorSelectedId = typeof this.state.lineColor !== 'undefined' ? this.state.lineColor.id : undefined;

        LineColorAPI.list(selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const totalPages = PaginationHelper.getTotalPages(data.length, this.state.elementsPerPage);
                this.setState({
                    lineColors: data,
                    currentPage: this.state.currentPage > totalPages ? totalPages : this.state.currentPage,
                    lineColor: typeof lineColorSelectedId !== 'undefined' ? data.filter(lineColor => lineColor.id === lineColorSelectedId)[0] : undefined,
                    nameInputError: null,
                    backColorInputError: null,
                    paperColorInputError: null,
                    foreColorInputError: null,
                    showLineColorForm: false,
                    showDeleteModal: false,
                    showExecutingModal: false,
                    loading: false
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true,
                    errorLoading: true,
                })
            });
    }

    updateLineColorValue = (e, value) => {
        let { lineColor } = this.state;

        if (value === 'backColor' || value === 'paperColor' || value === 'foreColor') {
            lineColor[value] = e.rgb;
        } else {
            lineColor[value] = e.target.value;
        }

        this.setState({
            lineColor
        })
    }

    createShadeValue = (shade) => {
        let { lineColor } = this.state;

        if (lineColor.shades.length < 5) {
            if (shade !== undefined) {
                lineColor.shades.push(shade);
            }
        } else {
            this.setState({
                alertTitle: "Aviso",
                alertMessage: 'O limite de 5 tonalidades por cor foi atingido.',
                alertStyle: 'warning',
                icon: 'alert',
                showErrorModal: true
            })
        }

        this.setState({
            lineColor
        })
    }

    editShadeValue = (rgb, index) => {
        if (!rgb) return;

        const lineColor = Object.assign({}, this.state.lineColor);
        if (!lineColor.shades[index]) return;

        lineColor.shades[index].val = rgb;

        this.setState({ lineColor });
    };

    removeShadeValue = (index) => {
        let { lineColor } = this.state;

        lineColor.shades.splice(index, 1);

        this.setState({
            lineColor
        })
    }

    saveLineColor = () => {
        if (this.state.lineColor.id !== undefined) {

            if (this.validInput()) {
                this.setState({
                    showExecutingModal: true
                }, () => {
                    LineColorAPI.update(this.state.lineColor.id, this.state.lineColor)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Sucesso",
                                alertMessage: 'Cor alterada com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                lineColor: undefined,
                                showErrorModal: true
                            });
                            this.getLineColors();
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Erro",
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            });
                            this.getLineColors();
                        })
                });
            }
        } else {
            if (this.validInput()) {
                this.setState({
                    showExecutingModal: true
                }, () => {
                    LineColorAPI.create(this.state.lineColor)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: 'Sucesso',
                                alertMessage: 'Cor criada com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                showErrorModal: true
                            });
                            this.getLineColors();
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: 'Erro',
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            });
                            this.getLineColors();
                        })
                });
            }
        }
    }

    validInput() {
        let { nameInputError, backColorInputError, paperColorInputError, foreColorInputError } = this.state;
        let errors = 0;

        nameInputError = null;
        backColorInputError = null;
        backColorInputError = null;
        foreColorInputError = null;

        if (this.state.lineColor.name === "") {
            nameInputError = 'error';
            errors++;
        }

        if (this.state.lineColor.backColor === "") {
            backColorInputError = 'error';
            errors++;
        }

        if (this.state.lineColor.paperColor === "") {
            paperColorInputError = 'error';
            errors++;
        }

        if (this.state.lineColor.foreColor === "") {
            foreColorInputError = 'error';
            errors++;
        }

        this.setState({
            nameInputError,
            backColorInputError,
            paperColorInputError,
            foreColorInputError
        })

        return errors > 0 ? false : true;
    }

    deleteLineColor = (isToExecute) => {
        if (isToExecute) {
            this.setState({
                showDeleteModal: false,
                showExecutingModal: true
            }, () => {
                LineColorAPI.delete(this.state.lineColor.id)
                    .then(() => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Sucesso",
                            alertMessage: 'Cor removida com sucesso.',
                            alertStyle: 'success',
                            icon: 'ok',
                            showErrorModal: true
                        });
                        this.getLineColors();
                    }).catch((err) => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Erro",
                            alertMessage: err.message,
                            alertStyle: 'danger',
                            icon: 'remove',
                            showErrorModal: true
                        });
                        this.getLineColors();
                    })
            });
        }

        this.setState({
            showDeleteModal: false
        })
    }

    handleCreateClick = () => {
        this.setState({
            lineColor: {
                name: "", backColor: "", paperColor: "", foreColor: "", shades: []
            },
            showLineColorForm: true,
            title: 'Criar'
        })
    }

    handleEditClick = (color) => {
        this.setState({
            lineColor: color,
            showLineColorForm: true,
            title: 'Editar'
        })
    }

    handleDeleteClick = (color) => {
        this.setState({
            lineColor: color,
            showDeleteModal: true,
            alertTitle: "Aviso",
            alertMessage: `Tem a certeza que pretende eliminar a cor ${color.name}?`,
            icon: 'alert',
            alertStyle: "warning"
        })
    }

    clearError = () => {
        this.setState({
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
            showErrorModal: false
        })
    }

    onChangePage = (page) => {
        this.setState({
            currentPage: page
        });
    }

    onChangeElementsPerPage = (elements) => {
        this.setState({
            elementsPerPage: elements
        });
    }

    onSearch(filter) {
        this.setState({
            filter: filter
        });
    }

    renderColorsTable(colors) {
        const { currentPage, elementsPerPage, filter } = this.state;

        const colorsFiltered = SearchHelper.search({
            filter: filter,
            data: colors,
            fields: ["name"]
        });
        const totalPages = PaginationHelper.getTotalPages(colorsFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const colorsToRender = colorsFiltered.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0).slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <Table responsive striped hover>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <ColumnResize className="columnResizer" />
                            <th>Cor Fundo</th>
                            <ColumnResize className="columnResizer" />
                            <th>Cor Papel</th>
                            <ColumnResize className="columnResizer" />
                            <th>Cor Texto</th>
                            <ColumnResize className="columnResizer" />
                            <th>Tonalidades</th>
                            <ColumnResize className="columnResizer" />
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            colorsToRender.map((lineColor, idx) =>
                                <tr key={`linecolor-${idx}`}>
                                    <td>{lineColor.name}</td>
                                    <td className="column_resizer_body" />
                                    <td>
                                        {
                                            typeof lineColor !== 'undefined'
                                                ?
                                                <span className="span-colors"
                                                    style={
                                                        {
                                                            backgroundColor: `rgba(${lineColor.backColor.r}, ${lineColor.backColor.g}, ${lineColor.backColor.b}, ${lineColor.backColor.a})`
                                                        }
                                                    }
                                                />
                                                :
                                                ''
                                        }
                                    </td>
                                    <td className="column_resizer_body" />
                                    <td>
                                        {
                                            typeof lineColor !== 'undefined'
                                                ?
                                                <span className="span-colors"
                                                    style={
                                                        {
                                                            backgroundColor: `rgba(${lineColor.paperColor.r}, ${lineColor.paperColor.g}, ${lineColor.paperColor.b}, ${lineColor.paperColor.a})`
                                                        }
                                                    }
                                                />
                                                :
                                                ''
                                        }
                                    </td>
                                    <td className="column_resizer_body" />
                                    <td>
                                        {
                                            typeof lineColor !== 'undefined'
                                                ?
                                                <span className="span-colors"
                                                    style={
                                                        {
                                                            backgroundColor: `rgba(${lineColor.foreColor.r}, ${lineColor.foreColor.g}, ${lineColor.foreColor.b}, ${lineColor.foreColor.a})`
                                                        }
                                                    }
                                                />
                                                :
                                                ''
                                        }
                                    </td>
                                    <td className="column_resizer_body" />
                                    <td>
                                        {
                                            lineColor.shades.length !== 0 &&
                                            lineColor.shades.map((sh, i) => {
                                                if (
                                                    sh &&
                                                    sh.val &&
                                                    typeof sh.val === 'object' &&
                                                    typeof sh.val.r === 'number' &&
                                                    typeof sh.val.g === 'number' &&
                                                    typeof sh.val.b === 'number'
                                                ) {
                                                    const a = typeof sh.val.a === 'number' ? sh.val.a : 1;

                                                    return (
                                                        <span
                                                            key={`gradient-${i}`}
                                                            className={`span-colors-gradients ${i !== 0 ? 'margin-left--10 span-colors-gradients-zindex-' + i : ''}`}
                                                            style={{
                                                                backgroundColor: `rgba(${sh.val.r}, ${sh.val.g}, ${sh.val.b}, ${a})`
                                                            }}
                                                        />
                                                    );
                                                }

                                                return null;
                                            })
                                        }
                                    </td>
                                    <td className="column_resizer_body" />
                                    <td>
                                        <ButtonToolbar className="pull-right">
                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.handleEditClick(lineColor)} />
                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteClick(lineColor)} />
                                        </ButtonToolbar>
                                    </td>

                                </tr>
                            )
                        }
                    </tbody>
                </Table >
                <PaginationBuilder currentPage={currentPage}
                    elementsPerPage={elementsPerPage}
                    dataLength={colorsFiltered.length}
                    onChangePage={this.onChangePage}
                    onChangeElementsPerPage={this.onChangeElementsPerPage} />
            </Grid>
        );
    }

    render() {
        if (!this.state.errorLoading) {
            let contents = this.state.loading
                ? <LoadingSpinner />
                : this.renderColorsTable(this.state.lineColors);

            return (
                <div>
                    {
                        this.state.loading
                            ?
                            null
                            :
                            <TitleRow title="Cores" showSeparator={true}>
                                <Col className="padding-0" xs={2} sm={1} md={4}>
                                    <ButtonToolbar className="pull-right title-row-col-btns">
                                        <Button onClick={this.handleCreateClick}>CRIAR</Button>
                                    </ButtonToolbar>
                                </Col>
                                <Col className="padding-0" xs={10} sm={11} md={8}>
                                    <div className="search-bar">
                                        <SearchBar onSearch={(a) => this.onSearch(a)} />
                                    </div>
                                </Col>
                            </TitleRow>
                    }
                    <div className="margin-top-15">
                        {contents}
                    </div>

                    <LineColorForm
                        show={this.state.showLineColorForm}
                        title={this.state.title}
                        onSave={this.saveLineColor}
                        lineColor={this.state.lineColor}
                        onHide={() => this.getLineColors()}
                        onChangeValue={this.updateLineColorValue}
                        onCreateShadeValue={this.createShadeValue}
                        onEditShadeValue={this.editShadeValue}
                        onRemoveShadeValue={this.removeShadeValue}
                        nameInputError={this.state.nameInputError}
                        backColorInputError={this.state.backColorInputError}
                        paperColorInputError={this.state.paperColorInputError}
                        foreColorInputError={this.state.foreColorInputError} />

                    <HandleDialog show={this.state.showDeleteModal} title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} onExit={this.deleteLineColor} />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal && false === this.state.showExecutingModal} onHide={this.clearError} />
                    <HandleMessage show={this.state.showExecutingModal} title={this.state.executingTitle} message={this.state.executingMessage} icon={this.state.exectuingIcon} style={this.state.executingStyle}
                        onHide={this.clearError} small noButtons />
                </div>
            );
        } else {
            return (
                <div>
                    <LoadingSpinner />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                </div>
            );
        }
    }
}
